import React, { useEffect, useState } from "react";
import doc5Service from "../../../services/doc5.service";
import Loadding from "../../common/loadding";
import { Tooltip } from "antd";

const GroupCheck = (props: { group: string; doc3Id: number; type: string }) => {
  const { group, doc3Id, type } = props;
  const [status, setStatus] = useState(false);
  const [send, setSend] = useState(false);
  // const [sendBy, setSendBy] = useState("");

  useEffect(() => {
    (async () => {
      doc5Service.checkStatusSend(doc3Id, group).then((res) => {
        if (Array.isArray(res.data) && res.data.length > 0) {
          setSend(true);
        } else {
          // setSendBy(res.data.sendBy);
          setSend(false);
        }
        setStatus(true);
      });
    })();
  }, [doc3Id, group]);

  if (!status) {
    return <Loadding />;
  }

  // console.log("send", send);
  if (!send) {
    return (
      <>
        <h6>
          <Tooltip title={`ยังไม่ส่ง ${type}5`} placement={"right"}>
            <span className="badge bg-danger rounded-pill">
              <i className="bi bi-x-circle" /> {group}
            </span>
          </Tooltip>
        </h6>
      </>
    );
  } else {
    return (
      <>
        <h6>
          <span className="badge bg-success rounded-pill">
            <i className="bi bi-check2-circle" />
            {/* {group} โดย{sendBy} */}
            {group}
          </span>
        </h6>
      </>
    );
  }
};

export default GroupCheck;
